// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-user-modal-share__code-snippet[data-v-554fd676]{border:1px solid var(--v-brand-dark-blue-base);border-radius:4px;box-sizing:border-box;color:var(--v-brand-grey-base);padding:5px;width:100%}", ""]);
// Exports
module.exports = exports;
